var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellular0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3984 0.666016H15.3984C14.8461 0.666016 14.3984 1.11373 14.3984 1.66602V10.3327C14.3984 10.885 14.8461 11.3327 15.3984 11.3327H16.3984C16.9507 11.3327 17.3984 10.885 17.3984 10.3327V1.66602C17.3984 1.11373 16.9507 0.666016 16.3984 0.666016ZM10.7316 2.99932H11.7316C12.2839 2.99932 12.7316 3.44703 12.7316 3.99932V10.3327C12.7316 10.8849 12.2839 11.3327 11.7316 11.3327H10.7316C10.1794 11.3327 9.73165 10.8849 9.73165 10.3327V3.99932C9.73165 3.44703 10.1794 2.99932 10.7316 2.99932ZM7.06517 5.33281H6.06517C5.51288 5.33281 5.06517 5.78052 5.06517 6.33281V10.3328C5.06517 10.8851 5.51288 11.3328 6.06517 11.3328H7.06517C7.61745 11.3328 8.06517 10.8851 8.06517 10.3328V6.33281C8.06517 5.78052 7.61745 5.33281 7.06517 5.33281ZM2.39844 7.33281H1.39844C0.846153 7.33281 0.398438 7.78053 0.398438 8.33281V10.3328C0.398438 10.8851 0.846153 11.3328 1.39844 11.3328H2.39844C2.95072 11.3328 3.39844 10.8851 3.39844 10.3328V8.33281C3.39844 7.78053 2.95072 7.33281 2.39844 7.33281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellular0);
export default __webpack_public_path__ + "static/media/cellular0.514e7948d906babcaedec246ac1c689b.svg";
export { ForwardRef as ReactComponent };